import axios from 'axios';
import { ValidateEmail } from './emailvalidations';
import {getJwtToken} from '../services/jwt.services';

const BASE_URL = process.env.REACT_APP_BASE_URL;
class SendGridServiceController {
  async getUserData(email,companyid, reporttype) {
    console.log("getUserData");
    if (companyid === 'undefined' || companyid === '')
    {
      companyid="Not Requred";
    }
    const jwtToken = getJwtToken();
    try {
      if (!ValidateEmail(email)) {
        return { data: { status: 'ERROR', email, reason: { reason: `Invalid Email ${email}` } } };
      }

      const apiUrl = `${BASE_URL}/sendgrid/blocks/${email}/${companyid}/${reporttype}`;
      const headers = {
        'Authorization': `Bearer ${jwtToken}`,
        'Content-Type': 'application/json', // Adjust the content type if needed
      };
      const result = await axios.get(apiUrl, {headers});
      console.log('resrut', result);
      return [result];
    } catch (_e) {
      const status = [{ data: {blocktype: reporttype, status: 'Error', email, reason: `User not valid for company ${companyid}`} }];
      console.log("SendGridServiceController (ERROR): getUserData ",_e.message)
      return {"status":"fail", data: status}
      //return [];
    }
  }
  async UnblockUser(email,companyid, reporttype) {
 
    if (companyid === 'undefined' || companyid === '')
    {
      companyid="Not Requred";
    }
    const jwtToken = getJwtToken();
    try {
      if (!ValidateEmail(email)) {
        return { data: { status: 'ERROR', email, reason: { reason: `Invalid Email ${email}` } } };
      }

      const apiUrl = `${BASE_URL}/sendgrid/blocks/delete/${email}/${companyid}/${reporttype}`;
      const headers = {
        'Authorization': `Bearer ${jwtToken}`,
        'Content-Type': 'application/json', // Adjust the content type if needed
      };
      const result = await axios.delete(apiUrl, {headers});

      return {"status":"ok", data: result}
    } catch (_e) {
      const status = [{ data: {blocktype: reporttype, status: 'Error', email, reason: `User not valid for company ${companyid}`} }];
      console.log("SendGridServiceController (ERROR): UnblockUser ",_e.message)
      return {"status":"fail", data: status}
      //return [];
    }
  }
  async getnewsletterbounces(){
   
    const jwtToken = getJwtToken();
    try {
    

      const apiUrl = `${BASE_URL}/sendgrid/events/status/newsletters/bounces`;
      const headers = {
        'Authorization': `Bearer ${jwtToken}`,
        'Content-Type': 'application/json', // Adjust the content type if needed
      };
      const result = await axios.get(apiUrl, {headers});

      return {"status":"ok", data: result}
    } catch (error) {
     
      return {"status":"fail", data: "fail"}
      //return [];
    }
  }
  async getnewsletterblocks(){
   
    const jwtToken = getJwtToken();
    try {
    

      const apiUrl = `${BASE_URL}/sendgrid/events/status/newsletters/blocks`;
      const headers = {
        'Authorization': `Bearer ${jwtToken}`,
        'Content-Type': 'application/json', // Adjust the content type if needed
      };
      const result = await axios.get(apiUrl, {headers});

      return {"status":"ok", data: result}
    } catch (error) {
     
      return {"status":"fail", data: "fail"}
      //return [];
    }
  }
  async removeCompany(company) {
  
    
    const jwtToken = getJwtToken();
    try {
   
      const apiUrl = `${BASE_URL}/sendgrid/events/status/newsletters/track/remove/${company.companyId}`;
      console.log("SEND ",apiUrl)
      const headers = {
        'Authorization': `Bearer ${jwtToken}`,
        'Content-Type': 'application/json', // Adjust the content type if needed
      };
      const result = await axios.delete(apiUrl, {headers});
      console.log('result', result);
      return [result];
    } catch (_e) {
      const status = [{reason: ""}];
      
      return {"status":"fail", data: status}
      //return [];
    }
  }
  async getcompanyActivityNewsletters(companyid){
   
    const jwtToken = getJwtToken();
    try {
    

      const apiUrl = `${BASE_URL}/sendgrid/events/messages/${companyid}/activity`;
      const headers = {
        'Authorization': `Bearer ${jwtToken}`,
        'Content-Type': 'application/json', // Adjust the content type if needed
      };
      const result = await axios.get(apiUrl, {headers});

      return {"status":"ok", data: result}
    } catch (error) {
     
      return {"status":"fail", data: "fail"}
      //return [];
    }
  }
  async getmsgdetails(companyid,msgid){
   
    const jwtToken = getJwtToken();
    try {
    

      const apiUrl = `${BASE_URL}/sendgrid/events/messages/${companyid}/msgid/${msgid}`;
      const headers = {
        'Authorization': `Bearer ${jwtToken}`,
        'Content-Type': 'application/json', // Adjust the content type if needed
      };
      const result = await axios.get(apiUrl, {headers});

      return {"status":"ok", data: result}
    } catch (error) {
     
      return {"status":"fail", data: "fail"}
      //return [];
    }
  }
  async repoll(companyid){
   
    const jwtToken = getJwtToken();
    try {
    
  
      const apiUrl = `${BASE_URL}/sendgrid/events/${companyid}/repoll`;
      const headers = {
        'Authorization': `Bearer ${jwtToken}`,
        'Content-Type': 'application/json', // Adjust the content type if needed
      };
      const result = await axios.post(apiUrl,{},{headers});
  
      return {"status":"ok", data: result}
    } catch (error) {
     
      return {"status":"fail", data: "fail"}
      //return [];
    }
  }
}





export const SendGridService = new SendGridServiceController();
